/**
 * @fileoverview Content Redux Selectors
 * @active Used in current Next.js App Router routes
 * 
 * These selectors are used by active components in the App Router implementation
 * to access content-related state such as navigation links, profile IDs, and search results.
 * 
 * @see {@link src/components/companies/NewCompanies.tsx} - ACTIVE component that uses these selectors
 * @see {@link src/store/content/content.slice.ts} - Content state management
 */

import { type RootState } from "../index";

const getCurrentNavLink = () => (state: RootState) => state.content.currentNavLink;
const getProfile_Company_id = () => (state: RootState) =>
  state.content.current_Profile_Company_Id;
const getSearchResults = () => (state: RootState) => state.content.searchResults;
const getProfile_Fund_id = () => (state: RootState) =>
  state.content.current_Profile_Fund_Id;
const getCompanyDetailsTabIndex = () => (state: RootState) =>
  state.content.companyDetailsTabIndex;
const getSelectedCompanyForCompare = () => (state: RootState) =>
  state.content.companyForCompare;
const getSortedParams = () => (state: RootState) => state.content.sortedParams;
const getStateSortedParams = () => (state: RootState) => state.content.stateSortedParams;
const getGrowingFilters = () => (state: RootState) => state.content.growingFilters;
const getOpenCard = () => (state: RootState) => state.content.openCard;
const getIsLoading = () => (state: RootState) => state.content.isLoading;
const getInvestingFunds = () => (state: RootState) => state.content.investingFunds;
const getSelectedCardAnalyzeFund = () => (state: RootState) =>
  state.content.selectedCardAnalyze;
const getSelectedCardAnalyzeFund2 = () => (state: RootState) =>
  state.content.selectedCardAnalyze2;
const getDefaultCardAnalyzeFund = () => (state: RootState) =>
  state.content.defaultCardAnalyze;
const getOwnershipList = () => (state: RootState) => state.content.ownershipList;
const getOngoingInvestingFunds = () => (state: RootState) =>
  state.content.ongoingInvestingFunds;
const getInvestChart = () => (state: RootState) => state.content.investChart;
const getOneNewInCompany = () => (state: RootState) => state.content.oneNewInCompany;
const getWithdrawInvestingFunds = () => (state: RootState) =>
  state.content.withdrawInvestingFunds;
const getIsOpenFilterBlock = () => (state: RootState) => state.content.isOpenFilterBlock;
const getCurrentFilterList = () => (state: RootState) => state.content.currentFilterList;
const getTempUser = () => (state: RootState) => state.content.tempUser;

const contentSelectors = {
  getCurrentNavLink,
  getProfile_Company_id,
  getSearchResults,
  getProfile_Fund_id,
  getCompanyDetailsTabIndex,
  getSelectedCompanyForCompare,
  getSortedParams,
  getStateSortedParams,
  getGrowingFilters,
  getOpenCard,
  getIsLoading,
  getInvestingFunds,
  getSelectedCardAnalyzeFund,
  getDefaultCardAnalyzeFund,
  getSelectedCardAnalyzeFund2,
  getOwnershipList,
  getOngoingInvestingFunds,
  getInvestChart,
  getWithdrawInvestingFunds,
  getOneNewInCompany,
  getIsOpenFilterBlock,
  getCurrentFilterList,
  getTempUser,
};

export default contentSelectors;
